import { toast } from 'react-toastify'

export const updateInstagramIntent = async ({
  token,
  instagramIDString,
  intent,
  intentJson,
  previousIntentId,
  onSuccess,
  onError
}: {
  token: any
  instagramIDString: string
  intent: any
  intentJson: any
  previousIntentId: number | string | null
  onSuccess?: () => void
  onError?: (error: any) => void
}) => {
  if (!token) {
    toast.error('Authorization token missing.')
    return
  }

  if (!instagramIDString) {
    toast.error('Missing Instagram ID.')
    return
  }

  const payload = {
    intentId: intent.id,
    previousIntentId,
    intentJson
  }

  try {
    const response = await fetch(
      `${
        process.env.REACT_APP_RESUME_PARSER_URL
      }/update/instagramApplicationInput?instagramIDString=${encodeURIComponent(
        instagramIDString
      )}`,
      {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    )

    if (!response.ok) {
      const errorData = await response.json().catch(() => null)
      const message = errorData?.message || response.statusText
      throw new Error(message)
    }

    toast.success('Intent updated successfully!')
    onSuccess?.()
  } catch (err) {
    console.error('Update error:', err)
    toast.error(`Failed to update intent: ${err instanceof Error ? err.message : 'Unknown error'}`)
    onError?.(err)
  }
}
